import axios from './axios';

export default {
  list: () => axios.get('/applications'),
  update: (id, payload) => axios.put(`/applications/${id}`, { application: payload }),
  enums: () => axios.get('/applications/enums'),
  create: () => axios.post('/applications'),
  delete: (id) => axios.delete(`/applications/${id}`),
};
